// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a0b7f495","488":"56774043","977":"37376528"}[chunkId] + ".chunk.js";
};